import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { DarkLayoutTitle } from "../../../../constants";
import { darkColors } from "../../../../data/layout/ThemeCustomizer";
import { addSideBarBackGround } from "../../../../reduxToolkit/reducers/layout/themeCustomizerSlice";

const DarkLayout = () => {
  const dispatch = useDispatch();
  const [colorBackground1, setColorBackground1] = useState("");
  const [colorBackground2, setColorBackground2] = useState("");

  const handleColorChange = (primaryColor: string, secondaryColor: string) => {
    dispatch(addSideBarBackGround("dark-only"));
    setColorBackground1(primaryColor);
    setColorBackground2(secondaryColor);
  };

  // Update CSS variables whenever colors change
  useEffect(() => {
    if (colorBackground1 && colorBackground2) {
      document.documentElement.style.setProperty("--theme-default", colorBackground1);
      document.documentElement.style.setProperty("--theme-secondary", colorBackground2);
    }
  }, [colorBackground1, colorBackground2]);

  return (
    <>
      <h6>{DarkLayoutTitle}</h6>
      <ul className="layout-grid dark">
        {darkColors.map((colorOption) => (
          <li key={colorOption.id} className="color-layout" data-attr={colorOption.name} data-primary={colorOption.primary} data-secondary={colorOption.secondary} onClick={() => handleColorChange(colorOption.primary, colorOption.secondary)}>
            <div />
          </li>
        ))}
      </ul>
    </>
  );
};

export default DarkLayout;